import { connect } from "react-redux";
import { getCurrentFilterObj, getCurrentTableData, getKpiSelected } from "../selectors";
import { fetchStats } from "../actions/stats";
import Table from "../components/Table/Table";

const mapStateToProps = (state, ownProps) => {
	const stats = state.stats || {};

	return {
		tableLoading: state.stats.tableLoading,
		data: getCurrentTableData(state),
		period: stats.period || [],
		kpi: getKpiSelected(state),
		filters: getCurrentFilterObj(state)
	};
};

export default connect(
	mapStateToProps,
	{fetchStats},
)(Table);



// WEBPACK FOOTER //
// src/modules/stats/containers/TableContainer.js